import styles from './MaxButton.pcss'

interface Props {
	disabled?: boolean
	onClick: () => void
}

export function MaxButton({ disabled, onClick }: Props) {
	return (
		<button
			type="button"
			className={styles.container}
			disabled={disabled}
			onClick={onClick}
		>
			Max
		</button>
	)
}
